import React, { useEffect, useState, useRef } from 'react'
import { Image, View, Text, Dimensions, Animated, KeyboardAvoidingView, StatusBar } from 'react-native'
import { StyleSheet } from 'react-native'
import { getPlatform } from '../utils/platformUtils'
import theme from '../../theme'
import { getLanguage } from './appBar/context/LocalizationContext'
import styles from './SplashStyles'
import { LinearGradient } from 'expo-linear-gradient'
import { LoginTheme } from '../../themeConstants'

const Splash = () => {
    const { languageFile } = getLanguage()
    const fadeAnim = useRef(new Animated.Value(0)).current

    useEffect(() => {
        Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 900, // Duración de la animación en milisegundos
            delay: 500, // Inicia la animación después de 3 segundos
            useNativeDriver: true,
        }).start()
    }, [fadeAnim])

    return (
        <LinearGradient
            style={styles.splashContainer}
            colors={[LoginTheme.splashGradientStartColor, LoginTheme.splashGradientEndColor]}
            start={{ x: 0, y: 0 }}
            end={{ x: 0, y: 1 }}
        >
            {/* <StatusBar backgroundColor={LoginTheme.splashGradientStartColor} barStyle='light-content' /> */}
            <Image
                source={require('./../../assets/splashAnimated.gif')}
                style={styles.splashgif}
                //    onAnimationEnd={() => setShowGif(false)}
            />
            <Animated.View style={[styles.claimContainer, { opacity: fadeAnim }]}>
                <Text style={styles.claimText}>{languageFile.splash_message}</Text>
            </Animated.View>
        </LinearGradient>
    )
}
export default Splash
